import { Pipe, PipeTransform } from '@angular/core';
import { addDays } from 'date-fns';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'extendedDisplayDateFormatter',
})
export class ExtendedDisplayDateFormatterPipe extends DatePipe implements PipeTransform {
  override transform(value: any, args?: any): any {
    const date = new Date(value);
    const today = new Date().setHours(0, 0, 0, 0);
    const tomorrow = addDays(new Date(), 1).setHours(0, 0, 0, 0);
    const yesterday = addDays(new Date(), -1).setHours(0, 0, 0, 0);
    if (date.setHours(0, 0, 0, 0) == today) {
      return 'Today, ' + super.transform(value, 'MMM d');
    } else if (date.setHours(0, 0, 0, 0) === tomorrow) {
      return 'Tomorrow, ' + super.transform(value, 'MMM d');
    } else if (date.setHours(0, 0, 0, 0) === yesterday) {
      return 'Yesterday, ' + super.transform(value, 'MMM d');
    } else {
      return super.transform(value, args);
    }
  }
}
